import { render, staticRenderFns } from "./ModelMain.vue?vue&type=template&id=98a86bcc&scoped=true"
import script from "./ModelMain.vue?vue&type=script&lang=js"
export * from "./ModelMain.vue?vue&type=script&lang=js"
import style0 from "./ModelMain.vue?vue&type=style&index=0&id=98a86bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a86bcc",
  null
  
)

export default component.exports